// [V2-KEEP] Hook for the S3 page (CdpReportsS3): popup data is loaded per provider on click.
// `load` = props.loadProviderDetail. The v1 page passes none: `open` runs right away, as before.
//   withProviderDetail(this.props.loadProviderDetail, row.ABBR, () => this.setState({ ...open popup }))
export const withProviderDetail = (load, target, open) => {
    if (!load) {
        return open();
    }

    return load(target).then((ok) => {
        if (ok) {
            open();
        }
    });
};
